import { logout } from '@/api/auth';
import './AccessDeniedScreen.css';

export default function AccessDeniedScreen() {
  const handleLogout = async () => {
    await logout();
    window.location.reload();
  };

  return (
    <main className="access-denied" aria-labelledby="access-denied-title">
      <section className="access-denied-card">
        <div className="access-denied-mark" aria-hidden="true">!</div>
        <p className="access-denied-kicker">TOBi access</p>
        <h1 id="access-denied-title">Access not available</h1>
        <p className="access-denied-message">
          This Google account is not currently authorized to use the assistant. Please sign in with an approved work account.
        </p>
        <button type="button" className="access-denied-button" onClick={() => void handleLogout()}>
          Sign out
        </button>
      </section>
    </main>
  );
}